import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBNCancellationStore = defineStore(
  'bnCancellationStore',
  () => {
    // Store Models

    const asic_key = ref('')
    const bn_name = ref('')
    const request_asic_key = ref('')

    const resetData = () => {
      asic_key.value = ''
      bn_name.value = ''
      request_asic_key.value = ''
    }

    const update = (order) => {
      asic_key.value = order.bn_cancellation.asic_key
      bn_name.value = order.bn_cancellation.bn_name
      request_asic_key.value = order.bn_cancellation.request_asic_key
    }

    return {
      bn_name,
      asic_key,
      request_asic_key,
      resetData,
      update
    }
  },
  { persist: true }
)
